import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { impactMetrics } from '../data/metrics';
export function ImpactMetrics() {
  return <section id="impact" className="bg-slate-50 py-24 lg:py-32" data-id="element-133" data-mp="ln8z2q5ilgm4">
      <div className="max-w-content mx-auto px-6 lg:px-10" data-id="element-134" data-mp="lp28uebfcgyc">
        <SectionHeading eyebrow="05 — Executive Impact" title="Capital Metrics at a Glance" description="Measurable outcomes from two decades of commercial and operational leadership." data-id="element-135" data-mp="ppm2v90pb4g9" />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-136" data-mp="1icgle0dyjtr3">
          {impactMetrics.map((metric, index) => <motion.div key={metric.label} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1],
          delay: index * 0.08
        }} className="bg-white border border-slate-200 p-8" data-id="element-137" data-mp="18nf7cfqz3mfr" data-mpi={index}>
              <div className="font-serif text-4xl font-bold text-navy" data-id="element-138" data-mp="2kpqv2q9en93v">{metric.value}</div>
              <div className="mt-1 h-[3px] w-10 bg-gold" data-id="element-139" data-mp="2fujy01an52nx" />
              <h3 className="mt-4 text-sm font-semibold text-slate-800" data-id="element-140" data-mp="2uhwkptc6pefw">{metric.label}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-141" data-mp="2pqeil1yfd7tc">{metric.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}